import React from 'react';
import { Space, Switch } from 'antd';
import { useAtom } from 'jotai';
import { Header, ToggleText } from './styled';
import { blueBarAtom } from '@src/components/ActionToolbar/atoms';

function DimensionViews() {
  const [blueBar, SetBlueBar] = useAtom(blueBarAtom);

  const handleBlueBarToggle = () => {
    SetBlueBar((blueBar) => !blueBar);
  };

  return (
    <Space direction="vertical">
      <Header>View in Dimensions</Header>
      <div>
        <Switch size="small" checked={blueBar} onChange={handleBlueBarToggle} />
        <ToggleText>Bar Indicators</ToggleText>
      </div>
    </Space>
  );
}

export default DimensionViews;
